module.exports = new __parcel__URL__("capacity-no-header-skeleton.tpl.61191f22.svg").toString();